"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSTAL_CODE = exports.COUNTRY = exports.ADMINISTRATIVE_AREA_LEVEL_2 = exports.ADMINISTRATIVE_AREA_LEVEL_1 = exports.DEFAULT_DEBOUNCE_DELAY = void 0;
exports.DEFAULT_DEBOUNCE_DELAY = 500;
exports.ADMINISTRATIVE_AREA_LEVEL_1 = 'administrative_area_level_1';
exports.ADMINISTRATIVE_AREA_LEVEL_2 = 'administrative_area_level_2';
exports.COUNTRY = 'country';
exports.POSTAL_CODE = 'postal_code';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZ29vZ2xlLXBsYWNlcy1hdXRvY29tcGxldGUvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVVLFFBQUEsc0JBQXNCLEdBQUcsR0FBRyxDQUFDO0FBRTdCLFFBQUEsMkJBQTJCLEdBQUcsNkJBQTZCLENBQUM7QUFDNUQsUUFBQSwyQkFBMkIsR0FBRyw2QkFBNkIsQ0FBQztBQUM1RCxRQUFBLE9BQU8sR0FBRyxTQUFTLENBQUM7QUFDcEIsUUFBQSxXQUFXLEdBQUcsYUFBYSxDQUFDIn0=